export default __webpack_public_path__ + "static/media/settings_24px.be6ef005.svg";